export enum FileScanResult {
	NotDone = "NotDone",
	Malicious = "Malicious",
	Safe = "Safe",
	InvalidType = "InvalidType",
}
